<template>
	<div  class="main-page">
	  <a-layout id="mainpage">
		  <Header :isShowSearchDivVal="true" :isShowLeftSiderVal="false"></Header>
		  <a-layout  class="layout-cont"> 
			<a-layout style="padding: 0 24px 24px" 
				class="mainRightCont mainRightCont-Search" 
				v-hammer:pan="handlePan" 
				v-hammer:swipe="handleSwipe" v-hammer:swipeleft="handleLeft" v-hammer:swiperight="handleRight"
			  >  
			  <p ref="pppRef"></p>
			  <a-layout-content  :style="{ paddingTop: '10px', margin: 0, minHeight: '280px'}" > 
				  <template v-if="listData.length>0">
						 <div class="demoDivList" :style="{left:(-(divWidth+pianYiLiang)+swipedDeltaX) + 'px',width:((divWidth+pianYiLiang)*3)+'px'}"> 
						   <div class="demoDiv" :style="{width:(divWidth)+'px',marginRight:pianYiLiang+'px' }">
								<ArtlistCom	:listDataVal="listDataPre" :stype="'prevpage'"  
								:pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'sdetail'"></ArtlistCom>
						   </div>	
						   <div class="demoDiv" :style="{width:(divWidth)+'px',marginRight:pianYiLiang+'px' }">
								<ArtlistCom :listDataVal="listData" :stype="'curpage'"
								:pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'sdetail'"></ArtlistCom>
							</div>			
							<div class="demoDiv" :style="{width:(divWidth)+'px',marginRight:pianYiLiang+'px' }">
								<ArtlistCom :listDataVal="listDataNext" :stype="'nextpage'"
								:pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'sdetail'"></ArtlistCom>
							</div>	 
						 </div>  
							<div class="paginationlist">
								<ul>
									<li>
										<a-pagination size="small"
										v-model="CurPage"
										:default-current="pagination.current"
										:total="pagination.total" 
										:page-size="pagination.pageSize" 
										@change="onChangePage"  
										/>
									</li>
								</ul>
							</div>
					</template>
					<template v-else>
						<a-empty :image="locale.emptyImage" :description="locale.emptyText" />
					</template>
					<p class="aspin-cls" :class="spinningPcls"><a-spin tip="加载中..." :delay="500" :spinning="spinning" /></p>
			  </a-layout-content> 
			</a-layout>
		  
		  </a-layout>
		</a-layout>
	  <img class="main-bg" src="@/assets/img/main/main-bg.png" alt="" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Header from "./modules/header2.vue"; 
import ArtlistCom from "./modules/artlist.vue";  
var GListData = [{
	id:0,
    title: '',
	ftitle:"",
	type:"word",
	src:"",
	read:true,
	cat:"",
  },];
export default {
  name: "mainPage",
  components: {
    Header, 	
	ArtlistCom,
  },
  data() {
	var _self=this;
    return { 
	  collapsed: false,
	  navShow:true,
	  
	  spinning:false,//加载
	  spinningPcls:"",
	  
	  xlVal:4,
	  pageSize:12,
	  
		listData:[], 
		listDataPre:[],
		listDataNext:[],
		
		keywords:"",
		CurPage:0,
		
		pagination: {
		  current:1,//当前页
		  onChange: function(page){
			_self.CurPage=page;
			_self.pagination.current=page;
			console.log(page); 
		  },
		  total:0,
		  pageSize:12,
		  size:'small',
		},
		locale:{
			emptyText:"搜索结果为空", 
			emptyImage:"/assets/img/main/empty-search.png",  
		},
		
		swipedDirection:"left",
		swipedDeltaX:0,
		
		divWidth:0,
		divHeight:0,
		pianYiLiang:55,
		demoDivListMoveX:0,
		
		windowWidth: 0,
    };
  },
  computed: {  	
  	  listDataVal() { 
  		  return this.$store.state.article.resDataSearch;
  	  },
  	  listDataPreVal(){
  		  return this.$store.state.article.resDataPreSearch;
  	  },
  	  listDataNextVal(){
  		  return this.$store.state.article.resDataNextSearch;
  	  },
  	  totalVal(){
  		  return this.$store.state.article.total;
  	  },	  
	  keywordsVal(){
		  return this.$store.state.article.searchKeyWords;
	  },
	  screenWidthVal(){
		  return this.$store.state.screenWidth;
	  }
  },
  watch:{  
	  // 使用watch来监听 响应数据的变化 
	  CurPage(newVal){
	  	console.log("CurPage-切换:",newVal);
		var _self=this;
		this.$store.commit("article/set_page",newVal);
		if(_self.keywords.length>0)
		{
			var params={
			  key:_self.keywords,
			  page:newVal,
			  pageSize:this.pageSize, 
			}; 
			this.requestpostV(_self,params); 
		}
	  },
	  listDataVal(newVal)
	  {
	  	this.listData=this.$store.state.article.resDataSearch;
	  	//console.log("m-watch-listDataValCur:",this.listData);
	  },	  
	  listDataPreVal(newVal)
	  {
	  	this.listDataPre=newVal;
	  	//console.log("m-watch-listDataPre:",newVal);
	  },
	  listDataNextVal(newVal)
	  {
	  	this.listDataNext=newVal;
	  	//console.log("m-watch-listDataNext:",newVal);
	  },
	  totalVal(newVal)
	  {
	  	this.pagination.total=newVal;//console.log("listDataVal:",newVal);		 
	  },
	  keywordsVal(newVal)
	  {
		  var _self=this;
		  this.keywords=newVal;
		  console.log("keywords-newVal:",newVal);
		  if(_self.keywords.length>0)
		  {
		  	this.$store.commit("article/set_page",1);
		  	this.$store.commit("article/set_total",0);
			
		  	var params={
		  	  key:_self.keywords,
		  	  page:1,
		  	  pageSize:this.pageSize, 
		  	};
		  	this.requestpostV(_self,params);
		  }
	  },
	  divWidth(newVal){
		  //屏幕尺寸变化时，触发
		  this.updateDimensions();
		  
		  var _self=this;
		  this.$store.commit("article/set_page",newVal);
		  if(_self.keywords.length>0)
		  {
		  	var params={
		  	  key:_self.keywords,
		  	  page:1,
		  	  pageSize:this.pageSize, 
		  	}; 
		  	this.requestpostV(_self,params); 
		  } 	
	  }, 
  },
  created() {	  
	var _self=this;
	//this.showLoading();
	  
	_self.keywords=_self.$route.query.ks.trim();
	//console.log("keywords:",_self.keywords); 
  },
  mounted() {
	  var _self=this;
	  //this.showLoading();
	  var div = this.$refs.demoDiv;	    
	  var divlist=this.$refs.pppRef;
	  var resizeObserver = new ResizeObserver(entries => {
	        for (let entry of entries) {
	          var cr = entry.contentRect;
			  _self.divWidth=cr.width;
			  //_self.demoDivListMoveX=_self.divWidth;
	          console.log('Width: ', cr.width); // 打印新的宽度值 
	        }
	 });
     resizeObserver.observe(divlist); // 开始观察目标元素的大小变化。	
	 this.updateDimensions();
	 window.addEventListener('resize', this.updateDimensions);	 
	 
	 if(_self.keywords.length>0)
	 {
		 _self.CurPage=1;
	 	this.$store.commit("article/set_page", _self.CurPage);
	 	this.$store.commit("article/set_total",0); 
	 	var params={
	 	  key:_self.keywords,
	 	  page:_self.CurPage,
	 	  pageSize:_self.pageSize, 
	 	};
	 	this.requestpostV(_self,params);
	 }	 
	 var screenWidth=this.screenWidthVal;
	 //console.log("screenWidth-----------------:",screenWidth);
	 
  },
  methods: {	  
	  onChangePage(pageNumber){
		 // this.pagination.onChange(pageNumber);
		 this.CurPage=pageNumber;
		 //this.$store.commit("article/set_page",pageNumber); 
		 //console.log(pageNumber);
	  },
	  updateDimensions() {
		this.windowWidth = window.innerWidth;
		//console.log("showLoading------------windowWidth:",this.windowWidth);
	  },
	  showLoading(){
		  var _self=this;
		  _self.spinningPcls="active";
		  _self.spinning=true;
		  console.log("showLoading------------:",_self.spinning);
	  }, 
	 handleLeft() { 
	   this.swipedDirection="left";
	   this.swipedDeltaX=0;
	 },
	 handleRight() {  
	   this.swipedDirection="right";
	   this.swipedDeltaX=0;
	 },
	 handlePan(event) 
	 {
	   if(Math.abs(event.deltaX)<150)
	   {
	   		this.swipedDeltaX=event.deltaX;
	   }
	 },
	 handleSwipe(event){
		//console.log("Swipe---");
	    //console.log('Swipe---水平移动距离['+this.swipedDirection+']:', event.deltaX); 
		 
		 //this.spinningPcls="active";
		 //this.spinning=true;
		 //this.showLoading();//掩藏
		 if(this.swipedDirection=="left")
		 {
		 	//左滑 下一页				
			if(Math.abs(event.deltaX)>150)
			{
				this.CurPage=parseInt(this.CurPage)+1;
				var totalPage=Math.ceil(this.pagination.total/this.pagination.pageSize);
				if(this.CurPage>=totalPage)
				{
					this.CurPage=totalPage;
				}
				this.pagination.current=this.CurPage;
				//console.log('totalPage:', totalPage+"---"+this.pagination.total+"---"+this.pagination.pageSize);
				//this.pagination.onChange(this.CurPage);//跳转页面
			}
		 }
		 if(this.swipedDirection=="right" )
		 {
		 	//右滑 上一页			
			if(Math.abs(event.deltaX)>150)
			{ 
				this.CurPage=parseInt(this.CurPage)-1;
				if(this.CurPage<=0)
				{
				   this.CurPage=1;
				}
				//this.pagination.onChange(this.CurPage);//跳转页面
				this.pagination.current=this.CurPage;
				
			} 
		 }
		 this.swipedDeltaX=0;
		 //this.$store.commit("article/set_page",this.pagination.current);
		 console.log("Val["+this.swipedDirection+"]:",this.swipedDeltaX);
		 console.log('水平移动距离[CurPage]:', parseInt(this.CurPage));
	 },
	 requestpostV(_self,params)
	 { 
		 this.xlVal=4;
		 params.pageSize=12;		 
		 if(this.windowWidth>1500)
		 {
		 	 this.xlVal=4;
		 	 params.pageSize=8;
		 }
		 _self.$store.commit("article/set_pageSize",params.pageSize);
		 _self.showLoading();
		 
		var cparmas=params;
		cparmas.istype="curpage";
		this.$store
		.dispatch("article/GetGlobalSearch",cparmas) //当前页
		.then(res=>{
			
			_self.spinningPcls="";
			_self.spinning=false;
			
			
			var nparmas=params;
			nparmas.istype="nextpage";//下一页
			nparmas.page=(params.page+1);
			_self.$store.dispatch("article/GetGlobalSearch",nparmas);				
		})
		.then(res=>{
			var pparmas=params;
			pparmas.istype="prepage";//上一页
			pparmas.page=(params.page-2);
			_self.$store.dispatch("article/GetGlobalSearch",pparmas);
		}); 
		
	 }
  },
};
</script>

<style lang="scss" scoped> 
.main-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f1f3f5;
  .main-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 300px;
    z-index: 0;
  } 
  #mainpage,.layout-cont,.mainRightCont{
	  background: unset;z-index: 1;
  }
} 

.mainRightCont{  
	position: relative; padding-left: 20px!important;margin-top: 44px;
	transition:all 0.3s;
	.artlist-item{
		position: relative;
		word-wrap: break-word;
		white-space: unset; 
		margin-bottom:40px;
		.artlist-item-pdf,.artlist-item-dir,.artlist-item-list{ 
			height: 158px; border-radius: 12px; padding:12px; overflow: hidden;
			transition:all 0.2s;
		}
		.artlist-item-pdf:hover,.artlist-item-dir:hover,.artlist-item-list:hover{ 
			border-radius: 0px;
			border: 2px solid rgba(31, 110, 238, 1);
			box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2); 
			transition:all 0.2s;
		}
		.artlist-item-pdf{ 
			position: relative; background-color: #fff; height: 149px; margin-top: 9px;
			li{ float: left;}
			li:nth-child(1){
				width: 13%; text-align: left;
				img{ max-width: 24px; height:auto;margin: 0px auto;display:inline-block}
			}
			
			li:nth-child(2){
				width: 70%; text-align: left; 
				h3{ 
					font-size: 16px; line-height: 24px; font-family: "Source Han Sans CN"; 
					font-weight: 600; margin-bottom: 8px;
					word-wrap: break-word;
					white-space:break-spaces;
				}
				h4{ font-size: 16px; font-family: "Source Han Sans CN"; }
			}
			li:nth-child(3){
				width: 15%;text-align: right;font-size: 14px;
				.color-green{color:rgba(0, 168, 112, 1)}
				.color-red{color:red}
				.color-red:before{content: ''; width:8px; height: 8px; border-radius: 8px; background-color: red;display: inline-block; margin-right: 5px; line-height:25px;}
			}
			li:nth-child(4){
				position: absolute;width: 80px;bottom: 15px;right: 10px; text-align: right;font-size: 14px; 
				font-family: "Source Han Sans CN";color:rgba(25, 26, 26, 1)
			}
		} 
		.artlist-item-dir{
			position: relative; background-color: unset; 
			.title-bk{
				position: absolute;top: 0px;left: 0;
				width:100%;height: 55px;
				background-image: url("/assets/img/item-title-dir.png"); background-position: top left; background-size: 100% 100%;
				span{
					display: block;width: 69px;height:22px;line-height: 22px; text-align:center;margin-left: 4px; margin-top: 7px;
					color: rgba(31, 110, 238, 1); font-weight:600; font-size: 14px;
				}
			}
			.cont-dir{ 
				width: 100%; height: 110px; position: absolute;left: 0px;bottom: 0px;
				background: linear-gradient(to bottom,#ecf3ff,#fefeff,#fefefe);
				.cont-dir-inform{ 
					 text-align: center; margin-top:16px;
					img{max-width: 32px;height: auto; margin: 0px auto;}
					span{font-size: 16px; line-height: 24px;color:rgba(25, 26, 26, 1);font-weight: 400;margin-top:8px; }
				}
			}
			
		}
		.artlist-item-list{ 
			position: relative; background-color: unset;
			.title-bk{
				position: absolute;top: 0px;left: 0;
				width:100%;height: 35px;
				background-image: url("/assets/img/item-title-list.png"); background-position: top left; background-size: 100% 100%;
				span{
					display: block;width: 69px;height:22px;line-height: 22px; text-align:center;margin-left: 4px;
					color: rgba(31, 110, 238, 1); font-weight:600; font-size: 14px;
				}
			}
			.cont-list{ 
				width: 100%; height: 128px; position: absolute;left: 0px;bottom: 0px;
				background: linear-gradient(to bottom,#ecf3ff,#fefeff,#fefefe);
				.cont-dl{
					width: 94%;height: 112px; margin: 0px auto; background-color: #fff;bottom:0px; border-radius: 12px;
					padding: 10px; padding-top: 12px; padding-bottom: 12px; 
					dd{ float: left;}
					dd:nth-child(1){
						width: 22px; text-align: left; margin-right: 8px; margin-left: 0px;
						img{ max-width: 22px; height:auto;float: left;}
					}
					dd:nth-child(2){
						width: 80%; text-align: left; 
						h3{ 
							font-size: 16px; line-height: 24px; font-family: "Source Han Sans CN"; 
							font-weight: 600; margin-bottom: 8px;
							word-wrap: break-word;
							white-space:break-spaces;
						}
						h4{ font-size: 16px; font-family: "Source Han Sans CN"; }
					}
				}
			}
		}
	}
	
	.pagination-2{
		padding-right: 10px;
		.ant-pagination{ text-align: right;}
	}
	.aspin-cls{ text-align: center; position: absolute;width: 100%; height: 50px; top: 33.3%;left: 0;z-index: 100; display: none;}
	.aspin-cls.active{ display: block;}
	
	.ant-layout-content{ position: relative; overflow: hidden;}
	.demoDivList{ display:flex;position: absolute;height: 100%;left: 0px; top: 0px;white-space: nowrap; transition:all 0.3s}
	.demoDiv{ position: relative;flex: 0 0 auto; height: 100%;left: 0px; top: 0px; display:block; float: left;}
}


	.paginationlist{ 
		 position: absolute;left: 0px;width: 100%; z-index: 100;bottom:0px;
		 ul{
			width: 100%; height: 30px; position: relative;
			li{width:100%; text-align: center;} 
		 }
	} 

	@media (max-width:420px){
		.artlist-item{  margin-top: 8px;}
	}
</style>
<style>
	.mainRightCont-Search{}
	.mainRightCont-Search .demoDiv .ant-list{ height: 100%;} 
</style>